/**
 * takes an object and returns an html-string
 * suitable to create a Google Maps Infowindow
 *
 * @param   {object} content
 *
 * @returns {string} - html-markup as string
 */

import returnAnonOwners from './returnAnonOwners'

const createWindowContent = (content) => {
  const anonOwners = returnAnonOwners(content.ownerCode)

  let parzNumber = ''
  content.parzNr.forEach((parzNr, index) => {
    if (!(parzNr === content.parzNr[index - 1])) {
      parzNumber += `${content.parzNr[0]}`
    }
  })
  /*
  let names = ''
  content.name.forEach((name, index) => {
    if (index === 0) {
      names += `<li class='owner'>
                          <a
                          href='#'
                          onclick='filterByOwner(this)'
                          data-owner='${name[1]}'
                          >
                            ${name[0]}
                        </a>
                  </li>`
    } else if (!(name[0][0] === content.name[index - 1][0][0])) {
      names += `<li class='owner'>
                          <a
                          href='#'
                          onclick='filterByOwner(this)'
                          data-owner='${name[1]}'
                          >
                            ${name[0]}
                        </a>
                  </li>`
    }
  })
*/
  let streets = ''
  content.street.forEach((street, index) => {
    if (index === 0) {
      streets += `<li>${street}</li>`
    } else if (!(street === content.street[index - 1])) {
      streets += `<li>${street}</li>`
    }
  })

  return `
  <div class='info-window'>
    <p>Parzellen-Nummer: ${parzNumber}</p>
    <h2>Eigentümer</h2>
    <ul>
      ${anonOwners}
    </ul>
    <h2>Adressen</h2>
    <ul>
      ${streets}
    </ul>
  </div>
  `
}

export default createWindowContent



// WEBPACK FOOTER //
// ./src/logic/createWindowContent.js